// src/platform/PlatformAdminLayout.jsx
import { Shield, Building2, Users, CreditCard, LogOut, Database, Map, LayoutDashboard } from "lucide-react";
import PlatformOrgsPage from "./PlatformOrgsPage";
import PlatformAdminContent from "./PlatformAdminContent";
import { useState } from "react";
import { logout } from "./platformLogout";

const NAV_ITEMS = [
    { id: "orgs", label: "Organizations", Icon: Building2 },
    { id: "datasets", label: "Datasets", Icon: Database },
    { id: "dataset_coverage", label: "Dataset Coverage", Icon: Map },
    { id: "coverage_aois", label: "Entitlement AOIs", Icon: Shield },
    { id: "operating_aois", label: "Operating AOIs", Icon: Map },
    { id: "licensing", label: "Licensing", Icon: CreditCard },
    // Read-only analytics across AI products. Last in the rail because it is the
    // only section that reports ON the platform rather than configuring it.
    { id: "ai_dashboards", label: "AI Dashboards", Icon: LayoutDashboard },
];

export default function PlatformAdminLayout() {
    const [active, setActive] = useState("orgs");

    // flex-1 min-h-0, not h-screen. App.jsx renders the banners above this in
    // normal flow, so a 100vh child overflows the clipped shell by exactly the
    // banner height.
    //
    // NOT h-full either, which was the first attempt: as a flex item,
    // height:100% resolves against the container's own 100vh and reproduces the
    // overflow it was meant to fix. flex-1 fills what the column actually has
    // left; min-h-0 lets it shrink below its content so the inner overflow-auto
    // scrolls rather than pushing the box open.
    return (
        <div className="flex-1 min-h-0 w-full bg-bg text-gray-100 flex">

            {/* LEFT RAIL */}
            <aside className="w-64 border-r border-bg-border bg-bg-soft flex flex-col">

                {/* HEADER FOOTER — logout  scope indicator */}
                <div className="px-3 py-3 border-b border-bg-border flex items-center justify-between">
                    <span className="text-xs text-fg-secondary">Internal use only</span>
                    <button
                        onClick={logout}
                        className="
                            w-8 h-8
                            flex items-center justify-center
                            rounded-md
                            border border-bg-border
                            bg-bg-soft
                            text-gray-400
                            hover:text-red-400
                            hover:border-red-500/50
                            hover:bg-red-500/10
                            transition"
                        title="Log out"
                    >
                        <LogOut size={14} />
                    </button>
                </div>

                <div className="h-14 flex items-center px-4 border-b border-bg-border">
                    <Shield className="text-orange-400 mr-2" size={18} />
                    <span className="font-semibold tracking-wide">
                        PLATFORM ADMIN
                    </span>
                </div>

                <nav className="flex-1 p-3 space-y-1">
                    {NAV_ITEMS.map(({ id, label, Icon }) => (
                        <button
                            key={id}
                            onClick={() => setActive(id)}
                            className={`w-full flex items-center gap-2 px-3 py-2 rounded text-sm
                                ${active === id
                                    ? "bg-accent-red/20 text-orange-400"
                                    : "text-gray-400 hover:text-gray-200 hover:bg-bg"
                                }`}
                        >
                            <Icon size={16} />
                            {label}
                        </button>
                    ))}
                </nav>
            </aside>

            {/* MAIN PANEL */}
            <main className="flex-1 overflow-auto">
                <PlatformAdminContent active={active} />
            </main>
        </div>
    );
}